import { makeSharedStyles } from "shared/theme/makeSharedStyles";

export const useStyles = makeSharedStyles({
    main: {
        "& .input-container": {
            width: "100%",
        },
    },
});
